import { GrpcWebImpl } from './IndexerGrpcWebImpl.js';
import { grpc, getGrpcTransport } from '../../utils/grpc.js';
/**
 * @hidden
 */
export default class BaseIndexerGrpcWebConsumer extends GrpcWebImpl {
    module = '';
    constructor(endpoint, metadata = {}) {
        const grpcMetadata = new grpc.Metadata();
        Object.keys(metadata).forEach((key) => grpcMetadata.set(key, metadata[key]));
        super(endpoint, { transport: getGrpcTransport(), metadata: grpcMetadata });
    }
}
export const getGrpcIndexerWebImpl = (endpoint, metadata) => new BaseIndexerGrpcWebConsumer(endpoint, metadata);
